import type { User } from '@libs/contexts';
import { ui } from '@libs/domain';
import { RestClient } from '@libs/rest-client';
import { Menu } from '@mui/material';
import { useItemNames } from '@ps-smart-cp/ppfw-client';
import { useNavigate } from 'react-router';
import { UserMenuItem } from './UserMenuItem';

interface UserMenuProps {
  user: User;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}

export function UserMenu(props: UserMenuProps) {
  const { user, anchorEl, setAnchorEl } = props;
  const navigate = useNavigate();
  const getLinkName = useItemNames(ui.linkNames);

  return (
    <Menu
      anchorEl={anchorEl}
      id="user-menu"
      open={Boolean(anchorEl)}
      onClick={() => setAnchorEl(null)}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      transitionDuration={0}
      slotProps={{
        list: { disablePadding: true },
      }}
    >
      {(user.type === 'ROOT' || user.isAdmin) && (
        <UserMenuItem
          id="manage-system"
          name={getLinkName('toSystemManagement')}
          onClick={() => navigate('/system-management/main-menu')}
        />
      )}
      <UserMenuItem
        id="change-password"
        name={getLinkName('changePassword')}
        onClick={() => {
          navigate('/user/change-password');
        }}
      />
      {user.type === 'ROOT' && (
        <UserMenuItem
          id="mfa-setting"
          name={getLinkName('mfaSetting')}
          onClick={() => {
            navigate('/user/mfa-setting');
          }}
        />
      )}
      {user.type === 'IAM' && (
        <UserMenuItem
          id="webhook-token"
          name={getLinkName('webhookToken')}
          onClick={() => {
            navigate('/user/webhook-token');
          }}
        />
      )}
      <UserMenuItem
        id="logout"
        name={getLinkName('logout')}
        onClick={async () => {
          try {
            await RestClient.auth.delete('/auth/session');
          } catch (error) {
            console.debug(error);
          } finally {
            navigate('/');
          }
        }}
      />
    </Menu>
  );
}
